import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import Header from '../common/Header';
import { StyledBlock } from '../StyledComponents';
import ActionsSection from '../ActionsSection';

const i18nScope = 'authorizationRestorePinPage';

const AuthorizationRestorePinPage = ({ match }) => (
  <>
    <Header title={i18n.t(`${i18nScope}.title`)} description={i18n.t(`${i18nScope}.description`)} />
    <StyledBlock>
      <ActionsSection defaultSection>
        <ActionsSection.Link label={i18n.t(`${i18nScope}.phone`)} to={`${match.url}/phone`} />
        <ActionsSection.Link label={i18n.t(`${i18nScope}.email`)} to={`${match.url}/email`} />
      </ActionsSection>
    </StyledBlock>
  </>
);

AuthorizationRestorePinPage.propTypes = {
  match: PropTypes.object.isRequired,
};

export default AuthorizationRestorePinPage;
